[
  {
    "label": "slNo",
    "displayLabel": "SL No.",
    "editable": false
  },
  {
    "label": "code",
    "displayLabel": "Charge Code",
    "editable": false
  },
  {
    "label": "name",
    "displayLabel": "Charge Name",
    "editable": false
  },
  {
    "label": "active",
    "displayLabel": "Status",
    "editable": false
  },
  {
    "label": "periodicCharge",
    "displayLabel": "Periodic Charge",
    "editable": true,
    "fieldInfo": {
      "dataType": "boolean"
    }
  }
]
